import request from '@/utils/request'
export default {
  sendFeedback (subject, message) {
    const params = { subject: subject, message: message }
    return request.post('/api/v1/qp/users/feedback', params)
  },
  authorizeTerms () {
    return request.post('/api/v1/qp/users/authorization', { qp_authorization: 1 })
  },
  checkUserEmail (email) {
    return request.post('/api/v1/qp/users/check_email', { email })
  },
  resetPasswordUser ({ password, confirmedPassword, token }) {
    return request.put('/accounts/password.json',
      {
        account: {
          password: password,
          password_confirmation: confirmedPassword,
          reset_password_token: token
        }
      }
    )
  },
  applyQpAccount (param) {
    // name Required Type: String
    // email Required Type: String
    // company_name Required Type: String
    // collaboration Required Type: Boolean
    // job_title Option Type: String
    // telephone Option Type: String
    // note Option Type: String
    const { name, email } = param
    if (name && email && param['company_name']) {
      return request.post('/api/v1/qp/users/apply_qp_account', param)
    } else {
      return Promise.reject(new Error('required field not filled'))
    }
  }
}
